import { useContext } from 'react';
import { ModalContext, ModalType } from '../../../context/ModalContext';
import { useTaskGroupContext } from '../../Backlog/TaskGroupSection/TaskGroupContext';
import { Column } from '../../../types/WorkspaceViewColumn';
import { TaskStatus } from '../../../types/TaskStatus';
import { User } from '../../../types/User';
import { TaskType } from '../../../types/TaskType';
import { useViewContext } from '../../../pages/Space/Context/ViewContext';
import { WorkspaceViewEntityType } from '../../../types/WorkspaceView';

type NewTaskButtonProps = {
  isTableEmpty: boolean;
  hasRowSelection: boolean;
};

export const NewTaskButton = (props: NewTaskButtonProps) => {
  const { openModal } = useContext(ModalContext);

  const { groupBy, groupItem } = useTaskGroupContext() ?? { groupBy: undefined, groupItem: undefined };
  const viewContext = useViewContext();

  const onCreateTask = () => {
    let modalProps = {};
    if (groupBy === Column.epic) {
      modalProps = { epicId: groupItem?.id };
    } else if (groupBy === Column.taskType) {
      modalProps = { taskType: groupItem as TaskType };
    } else if (groupBy === Column.assignee) {
      modalProps = { assignee: groupItem as User };
    } else if (groupBy === Column.status) {
      modalProps = { status: groupItem as TaskStatus };
    } else if (groupBy === Column.estimate) {
      modalProps = { estimate: groupItem as number };
    }
    if (viewContext?.view?.entityType === WorkspaceViewEntityType.epic) {
      modalProps = { taskType: TaskType.epic };
    }
    openModal(ModalType.CreateItem, modalProps);
  };

  return (
    <div
      className="text-neutral-900 flex items-center gap-2 h-[40px]"
      style={{
        fontSize: '14px',
        borderTop: props.isTableEmpty ? '1px solid var(--color-neutral-300)' : undefined,
        marginLeft: props.hasRowSelection ? '100px' : '82px',
      }}
    >
      <div className="hover:text-taskonioGreen-600 cursor-pointer" onClick={onCreateTask}>
        + Add {viewContext?.view?.entityType === WorkspaceViewEntityType.epic ? 'Epic' : 'Task'}
      </div>
    </div>
  );
};
